export const OPEN_CART = "OPEN_CART"
export const CLOSE_CART = "CLOSE_CART"
export const SET_DEEP_LINK_META = "SET_DEEP_LINK_META"
export const CLEAR_DEEP_LINK_META = "CLEAR_DEEP_LINK_META"

export const setDeepLinkMeta = ({ sourceOrderId, cartId }) => ({
  type: SET_DEEP_LINK_META,
  payload: { sourceOrderId, cartId }
})

export const clearDeepLinkMeta = () => ({ type: CLEAR_DEEP_LINK_META })

const initialState = {}

export default function cart(state = initialState, action) {
  switch (action.type) {
    case OPEN_CART:
      return { ...state, isVisible: true }
    case CLOSE_CART:
      return { ...state, isVisible: false }
    case SET_DEEP_LINK_META:
      return { ...state, deepLinkMeta: action.payload }
    case CLEAR_DEEP_LINK_META:
      return { ...state, deepLinkMeta: undefined }
    default:
      return state
  }
}
